// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__z1iSr","menu-item":"Menu_menu-item__yJEOd","menu-item-light":"Menu_menu-item-light__MPeTi","menu-item-dark":"Menu_menu-item-dark__x4GyF"};